import _ from 'lodash';
import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './GuidanceOccupation-hashed.scss';
import templateStr from 'text!./GuidanceOccupation.html';
import IndustryCodeUtil from '../../util/IndustryCodeUtil';
import IndustryCodeDirective from 'edge/platform/widgets/typeahead/matchContentDirectives/IndustryCode/IndustryCode';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            industryCode: '=',
            continueToNextPanel: '&',
            isActive: '&',
            isPanelValid: '&',
            transitionFn: '&'
        },
        template: cssUtil.hashTemplate(templateStr, styles),
        controller: ['$scope', 'guidance.GuidanceService', function ($scope, GuidanceService) {

            var AMOUNT_OF_OCCUPATIONS_TO_SHOW_IN_DROPDOWN = 5;
            var occupationsPromise = GuidanceService.getOccupations();

            $scope.occupationLookup = {
                getMatches: function getMatches(userInput) {
                    return occupationsPromise.then(function (occupations) {
                        return _(occupations).filter(function (code) {
                            return IndustryCodeUtil.toString(code).toLowerCase().includes((userInput || '').toLowerCase());
                        }).take(AMOUNT_OF_OCCUPATIONS_TO_SHOW_IN_DROPDOWN).valueOf();
                    });
                },
                /* This toString will return to the user the classification code of the selection */
                toString: IndustryCodeUtil.toString,
                directive: IndustryCodeDirective
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/directives/Occupation/GuidanceOccupation.js
// module id = 960
// module chunks = 0